// Teacher Dashboard API Endpoints

export enum URLs {
    //BASE_URL = "https://api.omrquiz.com/",
    BASE_URL = "https://api.qa.omrquiz.com/",
    //BASE_URL = "http://localhost:5002/",
    //BASE_URL = "/",
    //BASE_URL = "https://localhost:7081/",

    // -----------------------Auth APIs------------------------
    POST_LOGIN_ENDPOINT = 'api/Auth/Login',
    POST_SIGN_UP_ENDPOINT = 'api/Auth/Register',
    GET_DEFAULT_REGISTER_ENDPOINT = 'api/Auth/DefaultRegister',
    POST_KEYCLOAK_SYNC_ENDPOINT = 'auth/sync',

    // -----------------------Classes APIs------------------------
    GET_CLASS_ENDPOINT = 'api/classes',           // + /{id}
    GET_CLASSES_ENDPOINT = 'api/classes',         // + ?userId={userId}
    CREATE_CLASS_ENDPOINT = 'api/classes',        // + ?userId={userId}
    UPDATE_CLASS_ENDPOINT = 'api/classes',        // + /{id}
    DELETE_CLASS_ENDPOINT = 'api/classes',        // + /{id}
    GET_STUDENTS_COUNT_ENDPOINT = 'api/classes/students-count', // POST with classIds array

    // -----------------------Students APIs------------------------
    GET_STUDENT_ENDPOINT = 'api/students',        // + /{id}
    CREATE_STUDENT_ENDPOINT = 'api/students',     // classId in body
    UPDATE_STUDENT_ENDPOINT = 'api/students',     // + /{id}
    DELETE_STUDENT_ENDPOINT = 'api/students',     // + /{id}
    IMPORT_STUDENTS_CSV_ENDPOINT = 'api/students/import', // + ?classId={classId}
    GET_STUDENT_ANALYTICS_ENDPOINT = 'api/students', // + /{id}/analytics

    // -----------------------Student Details APIs------------------------
    GET_STUDENT_DETAILS_ENDPOINT = 'api/students',  // + /{id}
    UPDATE_STUDENT_DETAILS_ENDPOINT = 'api/students',  // + /{id}

    // -----------------------Grading Scales APIs------------------------
    GET_GRADING_SCALE_ENDPOINT = 'api/grading-scales',      // + /{id}
    GET_GRADING_SCALES_ENDPOINT = 'api/grading-scales',     // + ?userId={userId}
    CREATE_GRADING_SCALE_ENDPOINT = 'api/grading-scales',   // + ?userId={userId}
    UPDATE_GRADING_SCALE_ENDPOINT = 'api/grading-scales',   // + /{id}
    DELETE_GRADING_SCALE_ENDPOINT = 'api/grading-scales',   // + /{id}

    // -----------------------Answer Sheets APIs------------------------
    GET_ANSWER_SHEET_ENDPOINT = 'api/answer-sheets',      // + /{id}
    GET_ANSWER_SHEETS_ENDPOINT = 'api/answer-sheets',     // + ?userId={userId}
    GET_ANSWER_SHEETS_BY_ASSESSMENT_ENDPOINT = 'api/answer-sheets/assessment', // + /{assessmentId}
    CREATE_ANSWER_SHEET_ENDPOINT = 'api/answer-sheets',   // + ?userId={userId}
    UPDATE_ANSWER_SHEET_ENDPOINT = 'api/answer-sheets',   // + /{id}
    DELETE_ANSWER_SHEET_ENDPOINT = 'api/answer-sheets',   // + /{id}
    DOWNLOAD_ANSWER_SHEET_ENDPOINT = 'api/answer-sheets', // + /{id}/download
    DOWNLOAD_ALL_ANSWER_SHEETS_ENDPOINT = 'api/assessments', // + /{assessmentId}/answer-sheets/download

    // -----------------------Assessments APIs------------------------
    GET_ASSESSMENT_ENDPOINT = 'api/assessments',          // + /{id}
    GET_ASSESSMENTS_ENDPOINT = 'api/assessments',         // + ?userId={userId}
    CREATE_ASSESSMENT_ENDPOINT = 'api/assessments',       // POST
    UPDATE_ASSESSMENT_ENDPOINT = 'api/assessments',       // + /{id} (PATCH/PUT)
    DELETE_ASSESSMENT_ENDPOINT = 'api/assessments',       // + /{id}
    PUBLISH_ASSESSMENT_ENDPOINT = 'api/assessments',      // + /{id} (PATCH with status: "active")

    // -----------------------Gradings APIs------------------------
    GET_GRADING_ENDPOINT = 'api/gradings',
    GET_GRADINGS_ENDPOINT = 'api/gradings',
    CREATE_GRADING_ENDPOINT = 'api/gradings',
    UPDATE_GRADING_ENDPOINT = 'api/gradings',
    DELETE_GRADING_ENDPOINT = 'api/gradings',

    // -----------------------Batches APIs------------------------
    CREATE_BATCH_RECOGNITION = 'api/batches/recognition',
    BATCH_GENERATE_ANSWER_SHEETS_ENDPOINT = 'api/batches/answer-sheets', // + /{assessmentId}
}
